// The tutorial demo account can demonstrate every channel from the CRM.
export const isDemoAccount = accountId => String(accountId) === '638';

export const canCreateChannelFromCrm = (accountId, channel) =>
  isDemoAccount(accountId) || channel === 'website';
